import { render, staticRenderFns } from "./NavContentSidebar.vue?vue&type=template&id=1a4711de&"
import script from "./NavContentSidebar.vue?vue&type=script&lang=js&"
export * from "./NavContentSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports